import { render, staticRenderFns } from "./order-create-view.html?vue&type=template&id=4c3e3746&"
import script from "./order-create-view.js?vue&type=script&lang=js&"
export * from "./order-create-view.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports